import React, { Component, ReactElement } from 'react'
import { UserInfoContextProvider } from '../../React/Common/Contexts'
import { BaseContexts } from '../../React/Common/BaseContexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { LicenceManagementPageFeatureGate } from '../Guards/LicenceManagementPageFeatureGate'
import { RouteGuard } from '../Guards/RouteGuard'
import { LicenceManagementPage as LicenceManagementPageContent } from '../Components/Organisms/LicenceManagementPage/LicenceManagementPage'

/**
 * Routed page wrapper for the Fast Provisioning licence management page.
 */
@Route(RouteID.LICENCE_MANAGEMENT)
export class LicenceManagementPage extends Component {
    /**
     * Renders the guarded routed page.
     *
     * @returns Licence management page component tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.LICENCE_MANAGEMENT}>
                <LicenceManagementPageFeatureGate>
                    <BaseContexts>
                        <UserInfoContextProvider>
                            <LicenceManagementPageContent />
                        </UserInfoContextProvider>
                    </BaseContexts>
                </LicenceManagementPageFeatureGate>
            </RouteGuard>
        )
    }
}
